<template>
  <div>
    <div class="alert alert-success">
      <h3>Dziękujemy bardzo za wiadomość.</h3>
      <p>
        Zgłoszenie zostało zarejestrowane.
      </p>
      <p>Dodatkowo informujemy, że informację dotyczącą zgłoszenia przesłaliśmy na adres e-mail wskazany przez Pana/Panią w formularzu.</p>
    </div>
    <div>
      <a class="btn btn-primary mx-auto" @click="reload">{{$t('btn_label_close')}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "IcFormSentMikol",
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    reload() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
h3 {
  margin: 0 0 10px 0;
  font-size: 22px;
}
.alert {
  font-size: 18px;
}
</style>
